<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="[
              'Agente Rel.',
              'Data',
              'Qtde. Visitas PF',
              'Qtde. Visitas PJ',
              $lang.Common.DataTable.Actions
            ]"
            :showNew="true"
            :showSearch="false"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.funcionario ? obj.funcionario.nomePessoa : 'N/D'" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="formatDate(obj.dtInicioGiroCarteira)" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.qtdVisitasPf !== null ? obj.qtdVisitasPf.toString() : '0'" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.qtdVisitasPj !== null ? obj.qtdVisitasPj.toString() : '0'" />
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import GiroCarteiraRepository from '@/shared/http/repositories/configurations/girocarteira.js'

export default {
  name: 'RegionalList',
  mixins: [ActionsForm],
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      GiroCarteiraRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      GiroCarteiraRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).utcOffset(-3).format('DD/MM/YYYY')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/giroCarteira/components/list/GiroCarteiraList.vue